"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuDivider = void 0;
/*---------------------------------------------------------------------------------------------
 * Copyright (c) Bentley Systems, Incorporated. All rights reserved.
 * See LICENSE.md in the project root for license terms and full copyright notice.
 *--------------------------------------------------------------------------------------------*/
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var utils_1 = require("../utils");
require("@itwin/itwinui-css/css/menu.css");
/**
 * Divider between menu items. Should be used inside `Menu`.
 * @example
 * <Menu>
 *   {(close) => [
 *     <MenuItem key={0} onClick={() => {}}>
 *       Item #1
 *     </MenuItem>,
 *     <MenuDivider key={1} />,
 *     <MenuItem key={2} onClick={() => {}}>
 *       Item #2
 *     </MenuItem>,
 *   ]}
 * </Menu>
 */
var MenuDivider = function (props) {
    var className = props.className, rest = __rest(props, ["className"]);
    (0, utils_1.useTheme)();
    return (react_1.default.createElement("li", __assign({ role: 'separator', className: (0, classnames_1.default)('iui-menu-divider', className) }, rest)));
};
exports.MenuDivider = MenuDivider;
exports.default = exports.MenuDivider;
